import { useState } from 'react' 
import Header from './components/Header'
import Tasks from './components/Tasks'
import AddTask from './components/AddTask'


const App = () => {
  const [showAddTask, setShowAddTask] = useState(false)

  const [tasks, setTasks] = useState([
    {
         id: 1,
         text: 'Music Lesson',
         day: 'Friday at 2:30pm',
         reminder: true,
    },
    {
         id: 2,
         text: 'Make Dinner',
         day: 'Thursday 5:30pm',
         reminder: true,
    },
    {
         id: 3,
         text: 'Pick up the kids from school',
         day: 'Monday, 4:00pm',
         reminder: false,
    }
])

// Add Task
const addTask = (task) => {
  const id = Date.now()
  const newTask = {id, ...task}
  setTasks([...tasks, newTask])
}

//Delete a Task
const deleteTask = (id) => {
  setTasks(tasks.filter((task) => task.id !== id))
}

//Toggle Reminder
const toggleReminder = (id) => {
  setTasks(tasks.map((task) => task.id === id ? {...task, reminder: !task.reminder} : task
  )
  )
}
//const setTasks 


return (
    <div className='container'>
    <Header onAdd={() => setShowAddTask(!showAddTask)} showAdd={showAddTask}/>
    {showAddTask && <AddTask onAdd={addTask}/>}
    {tasks.length > 0 ? (
      <Tasks tasks={tasks} onDelete={deleteTask} onToggle={toggleReminder}/>
    ) : (
      'No tasks left.'
    )}
    </div>
  )
}

export default App 